module.exports = __webpack_public_path__ + "img/logo_ocbc.455eaa99.png";